import { Plural } from "@lingui/macro";
import { ApiEpBilling, IApiEpBillingProduct } from "@smp/api";
import { UiBox, UiGrid } from "@smp/ui";
import { testAppendAttr } from "@smp/utils";
import { useState } from "react";
import { useQuery } from "react-query";

import { BlockTryPro } from "@/components/blocks/block_try_pro";

import { DialogPurchase } from "../../dialog_purchase";
import { UiProduct } from "../../shared/ui_product";

export const Posts = ({
  onClose,
  onClickTryPro,
}: {
  onClose: () => void;
  onClickTryPro?: () => void;
}) => {
  const [product, setProduct] = useState<IApiEpBillingProduct | undefined>(
    undefined,
  );

  const { data: productPostsPackages } = useQuery(
    [
      "ep.billing.product.posts_package",
      {
        query: { is_single_payment_allowed: true },
      },
    ],
    () =>
      ApiEpBilling.Product.PostsPackage.list({
        query: { is_single_payment_allowed: true },
      }),
  );

  const handleClose = () => {
    setProduct(undefined);
    onClose();
  };

  const handleProductChange = (product: IApiEpBillingProduct) => {
    setProduct(product);
  };

  if (!productPostsPackages) {
    return null;
  }

  return (
    <>
      <UiBox>
        <UiGrid container spacing={2}>
          {productPostsPackages
            .sort((a, b) => {
              if (a.amount > b.amount) return 1;
              if (a.amount < b.amount) return -1;
              return 0;
            })
            .map((productPostsPackage) => (
              <UiGrid item key={productPostsPackage.id} xs={6} sm={4}>
                <UiProduct
                  {...testAppendAttr(
                    "id",
                    `buy_posts_${productPostsPackage.amount}`,
                  )}
                  fullWidth
                  key={productPostsPackage.id}
                  name={
                    <Plural
                      zero={`posts`}
                      one={`post`}
                      few={`posts`}
                      many={`posts`}
                      other={`posts`}
                      value={productPostsPackage.amount}
                    />
                  }
                  onClick={handleProductChange}
                  product={productPostsPackage}
                />
              </UiGrid>
            ))}
          <UiGrid item xs={12}>
            <BlockTryPro
              additionalAction={() => {
                onClose();
                onClickTryPro && onClickTryPro();
              }}
            />
          </UiGrid>
        </UiGrid>
      </UiBox>
      {!!product && (
        <DialogPurchase
          onClose={handleClose}
          open={!!product}
          product={product}
        />
      )}
    </>
  );
};
